import styled from '@emotion/styled';

/* Pagination footer - displays record count and navigation buttons */
export const PaginationFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  height: 50px;
  padding: 0 16px;
  gap: 16px;
  background-color: ${p => p.theme.palette.bg.primary};
  border-top: 1px solid ${p => p.theme.palette.border.primarySubtle};
`;

/* Record count text in pagination footer */
export const PaginationRecordCount = styled.span`
  flex: 1;
  font-size: 0.875rem;
  color: ${p => p.theme.palette.text.secondary};
`;

/* Spacer to balance the layout when navigation is centered */
export const PaginationSpacer = styled.div`
  flex: 1;
`;

/* Navigation buttons container in pagination footer */
export const PaginationNavButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

/* Navigation button in pagination footer */
export const PaginationNavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${p => p.theme.palette.text.secondary};
  transition: color 0.15s ease;

  &:hover:not(:disabled) {
    color: ${p => p.theme.palette.text.primary};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

/* Page info display in pagination footer */
export const PaginationPageInfo = styled.span`
  display: flex;
  align-items: center;
  padding: 0 8px;
  font-size: 1rem;
  color: ${p => p.theme.palette.text.secondary};
`;
